import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { Translate } from 'next-translate';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { HeaderCheckbox } from '../../header-checkbox';
import { ActivityRescheduleFormType } from '../form-type';

function reducer(
  state,
  action,
  { update, clearErrors, name, setValue, parentIndex },
) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            // const otherVal = () => {
            //   if (action.columnId === 'guestId') {
            //     const allPreference = [
            //       ...action.extra[0].extra.preferences,
            //       ...action.extra[0].extra.preferenceStats,
            //     ];
            //     return {
            //       guestPreferences: (allPreference || []).map((item) =>
            //         tagTransformer(item),
            //       ),
            //       guestName: `${capitalize(action.extra[0].extra.title)} ${
            //         action.extra[0].extra.name
            //       }`,
            //     };
            //   }
            //   return {};
            // };
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
              // ...otherVal(),
            };

            // update(index, tempValue);
            clearErrors(name);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });
            // clearErrors(`${name}.${action.rowIndex}.${action.columnId}`);
            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    case 'isSelected':
      return {
        ...state,
        data: state.data.map((row, index) => {
          const tempValue = {
            ...state.data[index],
            isSelected: action.value,
          };
          clearErrors(name);
          // update(index, tempValue);
          setValue(`${name}.${index}`, tempValue, { shouldValidate: true });

          return tempValue;
        }),
      };
    default:
  }
}

const _columns: ({
  t,
}: {
  t: Translate;
  dispatch?: any;
  name: any;
}) => IColumn<any>[] = ({ t, dispatch, name }) => [
  {
    header: () => <HeaderCheckbox name={name} dispatch={dispatch} />,
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    checkboxNoLabel: true,
    dataType: ColumnDataType.checkbox,
  },
  {
    header: t('common:guest'),
    accessorKey: 'guestName',
    minSize: 150,
    dataType: ColumnDataType.text,
    disabled: true,
  },
  {
    header: t('common:guest_preferences'),
    accessorKey: 'guestPreferences',
    minSize: 200,
    dataType: ColumnDataType.tags,
    tagKeyName: 'label',
    maxTags: 2,
    disabled: true,
  },
  {
    header: t('guest:booking_preferences'),
    accessorKey: 'preferences',
    minSize: 200,
    dataType: ColumnDataType.tags,
    tagKeyName: 'label',
    maxTags: 2,
    disabled: true,
  },
];

export default function ActivityRescheduleGuestTable({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const {
    control,
    formState: { isSubmitting },
    clearErrors,
    setValue,
  } = useFormContext<ActivityRescheduleFormType>();

  const name: any = `activitySales.${parentIndex}.activitySaleGuests`;

  const { update } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const fields = useWatch({
    control,
    name,
  });

  const columns = (dispatch?: any) => _columns({ t, name, dispatch });

  const [isInitiate, setIsInitiate] = React.useState<{
    value: boolean;
    data: any;
  }>({ value: false, data: undefined });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, {
        update,
        clearErrors,
        name,
        setValue,
        parentIndex,
      }),
    {
      columns: columns(),
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate.value) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate({
        value: true,
        data: fields.length ? fields : [],
      });
    }
  }, [fields, isInitiate]);

  React.useEffect(() => {
    if (!editable && isInitiate.value && !isSubmitting) {
      dispatch({ type: 'update_all', newData: isInitiate.data });
    }
  }, [editable, isInitiate.value, isSubmitting, t, isInitiate.data]);

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns(dispatch) as any}
        data={state.data}
        dispatch={dispatch}
        disabled={!editable}
        name={name}
        uniqueRowKey="customId"
        noAddRemoveRow
      />
    </div>
  );
}
